<template>
  <div>
    <button @click="order('new')" :class="{'selected': $store.getters.orderBy == 'new'}">Latest</button>
    <button @click="order('az')" :class="{'selected': $store.getters.orderBy == 'az'}">A-z</button>
    <button @click="order('za')" :class="{'selected': $store.getters.orderBy == 'za'}">Z-a</button>
    <button
      @click="order('favorite')"
      :class="{'selected': $store.getters.orderBy == 'favorite'}"
    >Favorites</button>
    <button
      @click="order('done')"
      :class="{'selected': $store.getters.orderBy == 'done'}"
    >Done</button>
    <button
      @click="order('random')"
      :class="{'selected': $store.getters.orderBy == 'random'}"
    >Random</button>
  </div>
</template>

<script>
export default {
  methods: {
    order(value) {
      // This makes the "order by" value available throughout the site
      this.$store.commit("setOrderBy", value);
      this.$store.dispatch("setFilteredRecipes");
    }
  }
};
</script>

<style lang="scss" scoped>
button {
  font-family: "Poppins";
}
</style>